<template>
  <div>

    <!-- View definitions modal template -->
    <b-modal ref="view-definitions"
             hide-footer
             @hide="hideTPModal"
    >
      <div class="d-block text-center">
        <h4 qid="view-definitions-title" v-if="type == 'business_impact'">
          {{ $t('risk_scenarios.business_impact_definitions') }}
        </h4>
        <h4 qid="view-definitions-title" v-if="type == 'business_probability'">
          {{ $t('risk_scenarios.business_probability_definitions') }}
        </h4>
        <h4 qid="view-definitions-title" v-if="type == 'privacy_impact'">
          {{ $t('risk_scenarios.privacy_impact_definitions') }}
        </h4>
        <h4 qid="view-definitions-title" v-if="type == 'privacy_probability'">
          {{ $t('risk_scenarios.privacy_probability_definitions') }}
        </h4>

        <h4 qid="view-definitions-title" v-if="type == 'business_confidentiality_impact'">
          {{ $t('risk_scenarios.business_confidentiality_impact_definitions') }}
        </h4>
        <h4 qid="view-definitions-title" v-if="type == 'business_integrity_impact'">
          {{ $t('risk_scenarios.business_integrity_impact_definitions') }}
        </h4>
        <h4 qid="view-definitions-title" v-if="type == 'business_availability_impact'">
          {{ $t('risk_scenarios.business_availability_impact_definitions') }}
        </h4>

        <h4 qid="view-definitions-title" v-if="type == 'privacy_confidentiality_impact'">
          {{ $t('risk_scenarios.privacy_confidentiality_impact_definitions') }}
        </h4>
        <h4 qid="view-definitions-title" v-if="type == 'privacy_integrity_impact'">
          {{ $t('risk_scenarios.privacy_integrity_impact_definitions') }}
        </h4>
        <h4 qid="view-definitions-title" v-if="type == 'privacy_availability_impact'">
          {{ $t('risk_scenarios.privacy_availability_impact_definitions') }}
        </h4>


        <h4 qid="view-definitions-title" v-if="type == 'business_confidentiality_probability'">
          {{ $t('risk_scenarios.business_confidentiality_probability_definitions') }}
        </h4>
        <h4 qid="view-definitions-title" v-if="type == 'business_integrity_probability'">
          {{ $t('risk_scenarios.business_integrity_probability_definitions') }}
        </h4>
        <h4 qid="view-definitions-title" v-if="type == 'business_availability_probability'">
          {{ $t('risk_scenarios.business_availability_probability_definitions') }}
        </h4>

        <h4 qid="view-definitions-title" v-if="type == 'privacy_confidentiality_probability'">
          {{ $t('risk_scenarios.privacy_confidentiality_probability_definitions') }}
        </h4>
        <h4 qid="view-definitions-title" v-if="type == 'privacy_integrity_probability'">
          {{ $t('risk_scenarios.privacy_integrity_probability_definitions') }}
        </h4>
        <h4 qid="view-definitions-title" v-if="type == 'privacy_availability_probability'">
          {{ $t('risk_scenarios.privacy_availability_probability_definitions') }}
        </h4>

      </div>

      <div v-if="type == 'business_impact'">

        <div v-if="object.risk_category.business_risk_impact_very_low_definition">
          <br>
          <label>{{ $t('impact.very_low') }}</label>
          <div v-if="object.risk_category.business_risk_impact_very_low_definition.length > 300">
            <p v-if="showFullBusinessRiskImpactVeryLowDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_impact_very_low_definition }}
            </p>
            <p v-if="!showFullBusinessRiskImpactVeryLowDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_impact_very_low_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullBusinessRiskImpactVeryLowDefinition=!showFullBusinessRiskImpactVeryLowDefinition">
              <span class="cursor-pointer" v-if="!showFullBusinessRiskImpactVeryLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullBusinessRiskImpactVeryLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.business_risk_impact_very_low_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.business_risk_impact_very_low_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.business_risk_impact_low_definition">
          <br>
          <label>{{ $t('impact.low') }}</label>
          <div v-if="object.risk_category.business_risk_impact_low_definition.length > 300">
            <p v-if="showFullBusinessRiskImpactLowDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_impact_low_definition }}
            </p>
            <p v-if="!showFullBusinessRiskImpactLowDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_impact_low_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullBusinessRiskImpactLowDefinition=!showFullBusinessRiskImpactLowDefinition">
              <span class="cursor-pointer" v-if="!showFullBusinessRiskImpactLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullBusinessRiskImpactLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.business_risk_impact_low_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.business_risk_impact_low_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.business_risk_impact_high_definition">
          <br>
          <label>{{ $t('impact.high') }}</label>
          <div v-if="object.risk_category.business_risk_impact_high_definition.length > 300">
            <p v-if="showFullBusinessRiskImpactHighDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_impact_high_definition }}
            </p>
            <p v-if="!showFullBusinessRiskImpactHighDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_impact_high_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullBusinessRiskImpactHighDefinition=!showFullBusinessRiskImpactHighDefinition">
              <span class="cursor-pointer" v-if="!showFullBusinessRiskImpactHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullBusinessRiskImpactHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.business_risk_impact_high_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.business_risk_impact_high_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.business_risk_impact_very_high_definition">
          <br>
          <label>{{ $t('impact.very_high') }}</label>
          <div v-if="object.risk_category.business_risk_impact_very_high_definition.length > 300">
            <p v-if="showFullBusinessRiskImpactVeryHighDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_impact_very_high_definition }}
            </p>
            <p v-if="!showFullBusinessRiskImpactVeryHighDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_impact_very_high_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullBusinessRiskImpactVeryHighDefinition=!showFullBusinessRiskImpactVeryHighDefinition">
              <span class="cursor-pointer" v-if="!showFullBusinessRiskImpactVeryHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullBusinessRiskImpactVeryHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.business_risk_impact_very_high_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.business_risk_impact_very_high_definition }}
          </p>
          <br>
        </div>
        <div class="text-center mt-5 mb-5"
             v-if="!object.risk_category.business_risk_impact_very_high_definition && !object.risk_category.business_risk_impact_high_definition && !object.risk_category.business_risk_impact_low_definition && !object.risk_category.business_risk_impact_very_low_definition"
        >
          <h5>{{ $t('system.no_definitions_available') }}</h5>
        </div>
      </div>


      <div v-if="type == 'business_confidentiality_impact'">

        <div v-if="object.risk_category.business_risk_confidentiality_impact_very_low_definition">
          <br>
          <label>{{ $t('impact.very_low') }}</label>
          <div v-if="object.risk_category.business_risk_confidentiality_impact_very_low_definition.length > 300">
            <p v-if="showFullBusinessRiskConfidentialityImpactVeryLowDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_confidentiality_impact_very_low_definition }}
            </p>
            <p v-if="!showFullBusinessRiskConfidentialityImpactVeryLowDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_confidentiality_impact_very_low_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullBusinessRiskConfidentialityImpactVeryLowDefinition=!showFullBusinessRiskConfidentialityImpactVeryLowDefinition">
              <span class="cursor-pointer" v-if="!showFullBusinessRiskConfidentialityImpactVeryLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullBusinessRiskConfidentialityImpactVeryLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.business_risk_confidentiality_impact_very_low_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.business_risk_confidentiality_impact_very_low_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.business_risk_confidentiality_impact_low_definition">
          <br>
          <label>{{ $t('impact.low') }}</label>
          <div v-if="object.risk_category.business_risk_confidentiality_impact_low_definition.length > 300">
            <p v-if="showFullBusinessRiskConfidentialityImpactLowDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_confidentiality_impact_low_definition }}
            </p>
            <p v-if="!showFullBusinessRiskConfidentialityImpactLowDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_confidentiality_impact_low_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullBusinessRiskConfidentialityImpactLowDefinition=!showFullBusinessRiskConfidentialityImpactLowDefinition">
              <span class="cursor-pointer" v-if="!showFullBusinessRiskConfidentialityImpactLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullBusinessRiskConfidentialityImpactLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.business_risk_confidentiality_impact_low_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.business_risk_confidentiality_impact_low_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.business_risk_confidentiality_impact_high_definition">
          <br>
          <label>{{ $t('impact.high') }}</label>
          <div v-if="object.risk_category.business_risk_confidentiality_impact_high_definition.length > 300">
            <p v-if="showFullBusinessRiskConfidentialityImpactHighDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_confidentiality_impact_high_definition }}
            </p>
            <p v-if="!showFullBusinessRiskConfidentialityImpactHighDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_confidentiality_impact_high_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullBusinessRiskConfidentialityImpactHighDefinition=!showFullBusinessRiskConfidentialityImpactHighDefinition">
              <span class="cursor-pointer" v-if="!showFullBusinessRiskConfidentialityImpactHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullBusinessRiskConfidentialityImpactHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.business_risk_confidentiality_impact_high_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.business_risk_confidentiality_impact_high_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.business_risk_confidentiality_impact_very_high_definition">
          <br>
          <label>{{ $t('impact.very_high') }}</label>
          <div v-if="object.risk_category.business_risk_confidentiality_impact_very_high_definition.length > 300">
            <p v-if="showFullBusinessRiskConfidentialityImpactVeryHighDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_confidentiality_impact_very_high_definition }}
            </p>
            <p v-if="!showFullBusinessRiskConfidentialityImpactVeryHighDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_confidentiality_impact_very_high_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullBusinessRiskConfidentialityImpactVeryHighDefinition=!showFullBusinessRiskConfidentialityImpactVeryHighDefinition">
              <span class="cursor-pointer" v-if="!showFullBusinessRiskConfidentialityImpactVeryHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullBusinessRiskConfidentialityImpactVeryHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.business_risk_confidentiality_impact_very_high_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.business_risk_confidentiality_impact_very_high_definition }}
          </p>
          <br>
        </div>
        <div class="text-center mt-5 mb-5"
             v-if="!object.risk_category.business_risk_confidentiality_impact_very_high_definition && !object.risk_category.business_risk_confidentiality_impact_high_definition && !object.risk_category.business_risk_confidentiality_impact_low_definition && !object.risk_category.business_risk_confidentiality_impact_very_low_definition"
        >
          <h5>{{ $t('system.no_definitions_available') }}</h5>
        </div>
      </div>




      <div v-if="type == 'business_integrity_impact'">

        <div v-if="object.risk_category.business_risk_integrity_impact_very_low_definition">
          <br>
          <label>{{ $t('impact.very_low') }}</label>
          <div v-if="object.risk_category.business_risk_integrity_impact_very_low_definition.length > 300">
            <p v-if="showFullBusinessRiskIntegrityImpactVeryLowDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_integrity_impact_very_low_definition }}
            </p>
            <p v-if="!showFullBusinessRiskIntegrityImpactVeryLowDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_integrity_impact_very_low_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullBusinessRiskIntegrityImpactVeryLowDefinition=!showFullBusinessRiskIntegrityImpactVeryLowDefinition">
              <span class="cursor-pointer" v-if="!showFullBusinessRiskIntegrityImpactVeryLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullBusinessRiskIntegrityImpactVeryLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.business_risk_integrity_impact_very_low_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.business_risk_integrity_impact_very_low_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.business_risk_integrity_impact_low_definition">
          <br>
          <label>{{ $t('impact.low') }}</label>
          <div v-if="object.risk_category.business_risk_integrity_impact_low_definition.length > 300">
            <p v-if="showFullBusinessRiskIntegrityImpactLowDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_integrity_impact_low_definition }}
            </p>
            <p v-if="!showFullBusinessRiskIntegrityImpactLowDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_integrity_impact_low_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullBusinessRiskIntegrityImpactLowDefinition=!showFullBusinessRiskIntegrityImpactLowDefinition">
              <span class="cursor-pointer" v-if="!showFullBusinessRiskIntegrityImpactLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullBusinessRiskIntegrityImpactLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.business_risk_integrity_impact_low_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.business_risk_integrity_impact_low_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.business_risk_integrity_impact_high_definition">
          <br>
          <label>{{ $t('impact.high') }}</label>
          <div v-if="object.risk_category.business_risk_integrity_impact_high_definition.length > 300">
            <p v-if="showFullBusinessRiskIntegrityImpactHighDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_integrity_impact_high_definition }}
            </p>
            <p v-if="!showFullBusinessRiskIntegrityImpactHighDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_integrity_impact_high_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullBusinessRiskIntegrityImpactHighDefinition=!showFullBusinessRiskIntegrityImpactHighDefinition">
              <span class="cursor-pointer" v-if="!showFullBusinessRiskIntegrityImpactHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullBusinessRiskIntegrityImpactHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.business_risk_integrity_impact_high_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.business_risk_integrity_impact_high_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.business_risk_integrity_impact_very_high_definition">
          <br>
          <label>{{ $t('impact.very_high') }}</label>
          <div v-if="object.risk_category.business_risk_integrity_impact_very_high_definition.length > 300">
            <p v-if="showFullBusinessRiskIntegrityImpactVeryHighDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_integrity_impact_very_high_definition }}
            </p>
            <p v-if="!showFullBusinessRiskIntegrityImpactVeryHighDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_integrity_impact_very_high_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullBusinessRiskIntegrityImpactVeryHighDefinition=!showFullBusinessRiskIntegrityImpactVeryHighDefinition">
              <span class="cursor-pointer" v-if="!showFullBusinessRiskIntegrityImpactVeryHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullBusinessRiskIntegrityImpactVeryHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.business_risk_integrity_impact_very_high_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.business_risk_integrity_impact_very_high_definition }}
          </p>
          <br>
        </div>
        <div class="text-center mt-5 mb-5"
             v-if="!object.risk_category.business_risk_integrity_impact_very_high_definition && !object.risk_category.business_risk_integrity_impact_high_definition && !object.risk_category.business_risk_integrity_impact_low_definition && !object.risk_category.business_risk_integrity_impact_very_low_definition"
        >
          <h5>{{ $t('system.no_definitions_available') }}</h5>
        </div>
      </div>




      <div v-if="type == 'business_availability_impact'">

        <div v-if="object.risk_category.business_risk_availability_impact_very_low_definition">
          <br>
          <label>{{ $t('impact.very_low') }}</label>
          <div v-if="object.risk_category.business_risk_availability_impact_very_low_definition.length > 300">
            <p v-if="showFullBusinessRiskAvailabilityImpactVeryLowDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_availability_impact_very_low_definition }}
            </p>
            <p v-if="!showFullBusinessRiskAvailabilityImpactVeryLowDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_availability_impact_very_low_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullBusinessRiskAvailabilityImpactVeryLowDefinition=!showFullBusinessRiskAvailabilityImpactVeryLowDefinition">
              <span class="cursor-pointer" v-if="!showFullBusinessRiskAvailabilityImpactVeryLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullBusinessRiskAvailabilityImpactVeryLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.business_risk_availability_impact_very_low_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.business_risk_availability_impact_very_low_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.business_risk_availability_impact_low_definition">
          <br>
          <label>{{ $t('impact.low') }}</label>
          <div v-if="object.risk_category.business_risk_availability_impact_low_definition.length > 300">
            <p v-if="showFullBusinessRiskAvailabilityImpactLowDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_availability_impact_low_definition }}
            </p>
            <p v-if="!showFullBusinessRiskAvailabilityImpactLowDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_availability_impact_low_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullBusinessRiskAvailabilityImpactLowDefinition=!showFullBusinessRiskAvailabilityImpactLowDefinition">
              <span class="cursor-pointer" v-if="!showFullBusinessRiskAvailabilityImpactLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullBusinessRiskAvailabilityImpactLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.business_risk_availability_impact_low_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.business_risk_availability_impact_low_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.business_risk_availability_impact_high_definition">
          <br>
          <label>{{ $t('impact.high') }}</label>
          <div v-if="object.risk_category.business_risk_availability_impact_high_definition.length > 300">
            <p v-if="showFullBusinessRiskAvailabilityImpactHighDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_availability_impact_high_definition }}
            </p>
            <p v-if="!showFullBusinessRiskAvailabilityImpactHighDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_availability_impact_high_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullBusinessRiskAvailabilityImpactHighDefinition=!showFullBusinessRiskAvailabilityImpactHighDefinition">
              <span class="cursor-pointer" v-if="!showFullBusinessRiskAvailabilityImpactHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullBusinessRiskAvailabilityImpactHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.business_risk_availability_impact_high_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.business_risk_availability_impact_high_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.business_risk_availability_impact_very_high_definition">
          <br>
          <label>{{ $t('impact.very_high') }}</label>
          <div v-if="object.risk_category.business_risk_availability_impact_very_high_definition.length > 300">
            <p v-if="showFullBusinessRiskAvailabilityImpactVeryHighDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_availability_impact_very_high_definition }}
            </p>
            <p v-if="!showFullBusinessRiskAvailabilityImpactVeryHighDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_availability_impact_very_high_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullBusinessRiskAvailabilityImpactVeryHighDefinition=!showFullBusinessRiskAvailabilityImpactVeryHighDefinition">
              <span class="cursor-pointer" v-if="!showFullBusinessRiskAvailabilityImpactVeryHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullBusinessRiskAvailabilityImpactVeryHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.business_risk_availability_impact_very_high_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.business_risk_availability_impact_very_high_definition }}
          </p>
          <br>
        </div>
        <div class="text-center mt-5 mb-5"
             v-if="!object.risk_category.business_risk_availability_impact_very_high_definition && !object.risk_category.business_risk_availability_impact_high_definition && !object.risk_category.business_risk_availability_impact_low_definition && !object.risk_category.business_risk_availability_impact_very_low_definition"
        >
          <h5>{{ $t('system.no_definitions_available') }}</h5>
        </div>
      </div>



      <div v-if="type == 'business_probability' || type == 'business_confidentiality_probability' || type == 'business_integrity_probability' || type == 'business_availability_probability'">

        <div v-if="object.risk_category.business_risk_probability_very_unlikely_definition">
          <br>
          <label>{{ $t('probability.very_unlikely') }}</label>
          <div v-if="object.risk_category.business_risk_probability_very_unlikely_definition.length > 300">
            <p v-if="showFullBusinessRiskProbabilityVeryUnlikelyDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_probability_very_unlikely_definition }}
            </p>
            <p v-if="!showFullBusinessRiskProbabilityVeryUnlikelyDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_probability_very_unlikely_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullBusinessRiskProbabilityVeryUnlikelyDefinition=!showFullBusinessRiskProbabilityVeryUnlikelyDefinition">
              <span class="cursor-pointer" v-if="!showFullBusinessRiskProbabilityVeryUnlikelyDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullBusinessRiskProbabilityVeryUnlikelyDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.business_risk_probability_very_unlikely_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.business_risk_probability_very_unlikely_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.business_risk_probability_unlikely_definition">
          <br>
          <label>{{ $t('probability.unlikely') }}</label>
          <div v-if="object.risk_category.business_risk_probability_unlikely_definition.length > 300">
            <p v-if="showFullBusinessRiskProbabilityUnlikelyDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_probability_unlikely_definition }}
            </p>
            <p v-if="!showFullBusinessRiskProbabilityUnlikelyDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_probability_unlikely_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullBusinessRiskProbabilityUnlikelyDefinition=!showFullBusinessRiskProbabilityUnlikelyDefinition">
              <span class="cursor-pointer" v-if="!showFullBusinessRiskProbabilityUnlikelyDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullBusinessRiskProbabilityUnlikelyDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.business_risk_probability_unlikely_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.business_risk_probability_unlikely_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.business_risk_probability_likely_definition">
          <br>
          <label>{{ $t('probability.likely') }}</label>
          <div v-if="object.risk_category.business_risk_probability_likely_definition.length > 300">
            <p v-if="showFullBusinessRiskProbabilityLikelyDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_probability_likely_definition }}
            </p>
            <p v-if="!showFullBusinessRiskProbabilityLikelyDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_probability_likely_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullBusinessRiskProbabilityLikelyDefinition=!showFullBusinessRiskProbabilityLikelyDefinition">
              <span class="cursor-pointer" v-if="!showFullBusinessRiskProbabilityLikelyDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullBusinessRiskProbabilityLikelyDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.business_risk_probability_likely_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.business_risk_probability_likely_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.business_risk_probability_very_likely_definition">
          <br>
          <label>{{ $t('probability.very_likely') }}</label>
          <div v-if="object.risk_category.business_risk_probability_very_likely_definition.length > 300">
            <p v-if="showFullBusinessRiskProbabilityVeryLikelyDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_probability_very_likely_definition }}
            </p>
            <p v-if="!showFullBusinessRiskProbabilityVeryLikelyDefinition" class="text-formatted">
              {{ object.risk_category.business_risk_probability_very_likely_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullBusinessRiskProbabilityVeryLikelyDefinition=!showFullBusinessRiskProbabilityVeryLikelyDefinition">
              <span class="cursor-pointer" v-if="!showFullBusinessRiskProbabilityVeryLikelyDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullBusinessRiskProbabilityVeryLikelyDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.business_risk_probability_very_likely_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.business_risk_probability_very_likely_definition }}
          </p>
          <br>
        </div>
        <div class="text-center mt-5 mb-5"
             v-if="!object.risk_category.business_risk_probability_very_likely_definition && !object.risk_category.business_risk_probability_likely_definition && !object.risk_category.business_risk_probability_unlikely_definition && !object.risk_category.business_risk_probability_very_unlikely_definition"
        >
          <h5>{{ $t('system.no_definitions_available') }}</h5>
        </div>
      </div>


      <div v-if="type == 'privacy_impact'">

        <div v-if="object.risk_category.privacy_risk_impact_very_low_definition">
          <br>
          <label>{{ $t('impact.very_low') }}</label>
          <div v-if="object.risk_category.privacy_risk_impact_very_low_definition.length > 300">
            <p v-if="showFullPrivacyRiskImpactVeryLowDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_impact_very_low_definition }}
            </p>
            <p v-if="!showFullPrivacyRiskImpactVeryLowDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_impact_very_low_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullPrivacyRiskImpactVeryLowDefinition=!showFullPrivacyRiskImpactVeryLowDefinition">
              <span class="cursor-pointer" v-if="!showFullPrivacyRiskImpactVeryLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullPrivacyRiskImpactVeryLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.privacy_risk_impact_very_low_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.privacy_risk_impact_very_low_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.privacy_risk_impact_low_definition">
          <br>
          <label>{{ $t('impact.low') }}</label>
          <div v-if="object.risk_category.privacy_risk_impact_low_definition.length > 300">
            <p v-if="showFullPrivacyRiskImpactLowDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_impact_low_definition }}
            </p>
            <p v-if="!showFullPrivacyRiskImpactLowDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_impact_low_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullPrivacyRiskImpactLowDefinition=!showFullPrivacyRiskImpactLowDefinition">
              <span class="cursor-pointer" v-if="!showFullPrivacyRiskImpactLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullPrivacyRiskImpactLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.privacy_risk_impact_low_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.privacy_risk_impact_low_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.privacy_risk_impact_high_definition">
          <br>
          <label>{{ $t('impact.high') }}</label>
          <div v-if="object.risk_category.privacy_risk_impact_high_definition.length > 300">
            <p v-if="showFullPrivacyRiskImpactHighDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_impact_high_definition }}
            </p>
            <p v-if="!showFullPrivacyRiskImpactHighDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_impact_high_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullPrivacyRiskImpactHighDefinition=!showFullPrivacyRiskImpactHighDefinition">
              <span class="cursor-pointer" v-if="!showFullPrivacyRiskImpactHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullPrivacyRiskImpactHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.privacy_risk_impact_high_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.privacy_risk_impact_high_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.privacy_risk_impact_very_high_definition">
          <br>
          <label>{{ $t('impact.very_high') }}</label>
          <div v-if="object.risk_category.privacy_risk_impact_very_high_definition.length > 300">
            <p v-if="showFullPrivacyRiskImpactVeryHighDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_impact_very_high_definition }}
            </p>
            <p v-if="!showFullPrivacyRiskImpactVeryHighDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_impact_very_high_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullPrivacyRiskImpactVeryHighDefinition=!showFullPrivacyRiskImpactVeryHighDefinition">
              <span class="cursor-pointer" v-if="!showFullPrivacyRiskImpactVeryHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullPrivacyRiskImpactVeryHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.privacy_risk_impact_very_high_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.privacy_risk_impact_very_high_definition }}
          </p>
          <br>
        </div>
        <div class="text-center mt-5 mb-5"
             v-if="!object.risk_category.privacy_risk_impact_very_high_definition && !object.risk_category.privacy_risk_impact_high_definition && !object.risk_category.privacy_risk_impact_low_definition && !object.risk_category.privacy_risk_impact_very_low_definition"
        >
          <h5>{{ $t('system.no_definitions_available') }}</h5>
        </div>
      </div>



      <div v-if="type == 'privacy_confidentiality_impact'">

        <div v-if="object.risk_category.privacy_risk_confidentiality_impact_very_low_definition">
          <br>
          <label>{{ $t('impact.very_low') }}</label>
          <div v-if="object.risk_category.privacy_risk_confidentiality_impact_very_low_definition.length > 300">
            <p v-if="showFullPrivacyRiskConfidentialityImpactVeryLowDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_confidentiality_impact_very_low_definition }}
            </p>
            <p v-if="!showFullPrivacyRiskConfidentialityImpactVeryLowDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_confidentiality_impact_very_low_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullPrivacyRiskConfidentialityImpactVeryLowDefinition=!showFullPrivacyRiskConfidentialityImpactVeryLowDefinition">
              <span class="cursor-pointer" v-if="!showFullPrivacyRiskConfidentialityImpactVeryLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullPrivacyRiskConfidentialityImpactVeryLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.privacy_risk_confidentiality_impact_very_low_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.privacy_risk_confidentiality_impact_very_low_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.privacy_risk_confidentiality_impact_low_definition">
          <br>
          <label>{{ $t('impact.low') }}</label>
          <div v-if="object.risk_category.privacy_risk_confidentiality_impact_low_definition.length > 300">
            <p v-if="showFullPrivacyRiskConfidentialityImpactLowDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_confidentiality_impact_low_definition }}
            </p>
            <p v-if="!showFullPrivacyRiskConfidentialityImpactLowDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_confidentiality_impact_low_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullPrivacyRiskConfidentialityImpactLowDefinition=!showFullPrivacyRiskConfidentialityImpactLowDefinition">
              <span class="cursor-pointer" v-if="!showFullPrivacyRiskConfidentialityImpactLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullPrivacyRiskConfidentialityImpactLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.privacy_risk_confidentiality_impact_low_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.privacy_risk_confidentiality_impact_low_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.privacy_risk_confidentiality_impact_high_definition">
          <br>
          <label>{{ $t('impact.high') }}</label>
          <div v-if="object.risk_category.privacy_risk_confidentiality_impact_high_definition.length > 300">
            <p v-if="showFullPrivacyRiskConfidentialityImpactHighDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_confidentiality_impact_high_definition }}
            </p>
            <p v-if="!showFullPrivacyRiskConfidentialityImpactHighDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_confidentiality_impact_high_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullPrivacyRiskConfidentialityImpactHighDefinition=!showFullPrivacyRiskConfidentialityImpactHighDefinition">
              <span class="cursor-pointer" v-if="!showFullPrivacyRiskConfidentialityImpactHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullPrivacyRiskConfidentialityImpactHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.privacy_risk_confidentiality_impact_high_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.privacy_risk_confidentiality_impact_high_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.privacy_risk_confidentiality_impact_very_high_definition">
          <br>
          <label>{{ $t('impact.very_high') }}</label>
          <div v-if="object.risk_category.privacy_risk_confidentiality_impact_very_high_definition.length > 300">
            <p v-if="showFullPrivacyRiskConfidentialityImpactVeryHighDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_confidentiality_impact_very_high_definition }}
            </p>
            <p v-if="!showFullPrivacyRiskConfidentialityImpactVeryHighDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_confidentiality_impact_very_high_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullPrivacyRiskConfidentialityImpactVeryHighDefinition=!showFullPrivacyRiskConfidentialityImpactVeryHighDefinition">
              <span class="cursor-pointer" v-if="!showFullPrivacyRiskConfidentialityImpactVeryHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullPrivacyRiskConfidentialityImpactVeryHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.privacy_risk_confidentiality_impact_very_high_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.privacy_risk_confidentiality_impact_very_high_definition }}
          </p>
          <br>
        </div>
        <div class="text-center mt-5 mb-5"
             v-if="!object.risk_category.privacy_risk_confidentiality_impact_very_high_definition && !object.risk_category.privacy_risk_confidentiality_impact_high_definition && !object.risk_category.privacy_risk_confidentiality_impact_low_definition && !object.risk_category.privacy_risk_confidentiality_impact_very_low_definition"
        >
          <h5>{{ $t('system.no_definitions_available') }}</h5>
        </div>
      </div>



      <div v-if="type == 'privacy_integrity_impact'">

        <div v-if="object.risk_category.privacy_risk_integrity_impact_very_low_definition">
          <br>
          <label>{{ $t('impact.very_low') }}</label>
          <div v-if="object.risk_category.privacy_risk_integrity_impact_very_low_definition.length > 300">
            <p v-if="showFullPrivacyRiskIntegrityImpactVeryLowDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_integrity_impact_very_low_definition }}
            </p>
            <p v-if="!showFullPrivacyRiskIntegrityImpactVeryLowDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_integrity_impact_very_low_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullPrivacyRiskIntegrityImpactVeryLowDefinition=!showFullPrivacyRiskIntegrityImpactVeryLowDefinition">
              <span class="cursor-pointer" v-if="!showFullPrivacyRiskIntegrityImpactVeryLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullPrivacyRiskIntegrityImpactVeryLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.privacy_risk_integrity_impact_very_low_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.privacy_risk_integrity_impact_very_low_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.privacy_risk_integrity_impact_low_definition">
          <br>
          <label>{{ $t('impact.low') }}</label>
          <div v-if="object.risk_category.privacy_risk_integrity_impact_low_definition.length > 300">
            <p v-if="showFullPrivacyRiskIntegrityImpactLowDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_integrity_impact_low_definition }}
            </p>
            <p v-if="!showFullPrivacyRiskIntegrityImpactLowDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_integrity_impact_low_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullPrivacyRiskIntegrityImpactLowDefinition=!showFullPrivacyRiskIntegrityImpactLowDefinition">
              <span class="cursor-pointer" v-if="!showFullPrivacyRiskIntegrityImpactLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullPrivacyRiskIntegrityImpactLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.privacy_risk_integrity_impact_low_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.privacy_risk_integrity_impact_low_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.privacy_risk_integrity_impact_high_definition">
          <br>
          <label>{{ $t('impact.high') }}</label>
          <div v-if="object.risk_category.privacy_risk_integrity_impact_high_definition.length > 300">
            <p v-if="showFullPrivacyRiskIntegrityImpactHighDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_integrity_impact_high_definition }}
            </p>
            <p v-if="!showFullPrivacyRiskIntegrityImpactHighDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_integrity_impact_high_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullPrivacyRiskIntegrityImpactHighDefinition=!showFullPrivacyRiskIntegrityImpactHighDefinition">
              <span class="cursor-pointer" v-if="!showFullPrivacyRiskIntegrityImpactHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullPrivacyRiskIntegrityImpactHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.privacy_risk_integrity_impact_high_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.privacy_risk_integrity_impact_high_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.privacy_risk_integrity_impact_very_high_definition">
          <br>
          <label>{{ $t('impact.very_high') }}</label>
          <div v-if="object.risk_category.privacy_risk_integrity_impact_very_high_definition.length > 300">
            <p v-if="showFullPrivacyRiskIntegrityImpactVeryHighDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_integrity_impact_very_high_definition }}
            </p>
            <p v-if="!showFullPrivacyRiskIntegrityImpactVeryHighDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_integrity_impact_very_high_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullPrivacyRiskIntegrityImpactVeryHighDefinition=!showFullPrivacyRiskIntegrityImpactVeryHighDefinition">
              <span class="cursor-pointer" v-if="!showFullPrivacyRiskIntegrityImpactVeryHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullPrivacyRiskIntegrityImpactVeryHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.privacy_risk_integrity_impact_very_high_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.privacy_risk_integrity_impact_very_high_definition }}
          </p>
          <br>
        </div>
        <div class="text-center mt-5 mb-5"
             v-if="!object.risk_category.privacy_risk_integrity_impact_very_high_definition && !object.risk_category.privacy_risk_integrity_impact_high_definition && !object.risk_category.privacy_risk_integrity_impact_low_definition && !object.risk_category.privacy_risk_integrity_impact_very_low_definition"
        >
          <h5>{{ $t('system.no_definitions_available') }}</h5>
        </div>
      </div>



      <div v-if="type == 'privacy_availability_impact'">

        <div v-if="object.risk_category.privacy_risk_availability_impact_very_low_definition">
          <br>
          <label>{{ $t('impact.very_low') }}</label>
          <div v-if="object.risk_category.privacy_risk_availability_impact_very_low_definition.length > 300">
            <p v-if="showFullPrivacyRiskAvailabilityImpactVeryLowDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_availability_impact_very_low_definition }}
            </p>
            <p v-if="!showFullPrivacyRiskAvailabilityImpactVeryLowDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_availability_impact_very_low_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullPrivacyRiskAvailabilityImpactVeryLowDefinition=!showFullPrivacyRiskAvailabilityImpactVeryLowDefinition">
              <span class="cursor-pointer" v-if="!showFullPrivacyRiskAvailabilityImpactVeryLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullPrivacyRiskAvailabilityImpactVeryLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.privacy_risk_availability_impact_very_low_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.privacy_risk_availability_impact_very_low_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.privacy_risk_availability_impact_low_definition">
          <br>
          <label>{{ $t('impact.low') }}</label>
          <div v-if="object.risk_category.privacy_risk_availability_impact_low_definition.length > 300">
            <p v-if="showFullPrivacyRiskAvailabilityImpactLowDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_availability_impact_low_definition }}
            </p>
            <p v-if="!showFullPrivacyRiskAvailabilityImpactLowDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_availability_impact_low_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullPrivacyRiskAvailabilityImpactLowDefinition=!showFullPrivacyRiskAvailabilityImpactLowDefinition">
              <span class="cursor-pointer" v-if="!showFullPrivacyRiskAvailabilityImpactLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullPrivacyRiskAvailabilityImpactLowDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.privacy_risk_availability_impact_low_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.privacy_risk_availability_impact_low_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.privacy_risk_availability_impact_high_definition">
          <br>
          <label>{{ $t('impact.high') }}</label>
          <div v-if="object.risk_category.privacy_risk_availability_impact_high_definition.length > 300">
            <p v-if="showFullPrivacyRiskAvailabilityImpactHighDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_availability_impact_high_definition }}
            </p>
            <p v-if="!showFullPrivacyRiskAvailabilityImpactHighDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_availability_impact_high_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullPrivacyRiskAvailabilityImpactHighDefinition=!showFullPrivacyRiskAvailabilityImpactHighDefinition">
              <span class="cursor-pointer" v-if="!showFullPrivacyRiskAvailabilityImpactHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullPrivacyRiskAvailabilityImpactHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.privacy_risk_availability_impact_high_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.privacy_risk_availability_impact_high_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.privacy_risk_availability_impact_very_high_definition">
          <br>
          <label>{{ $t('impact.very_high') }}</label>
          <div v-if="object.risk_category.privacy_risk_availability_impact_very_high_definition.length > 300">
            <p v-if="showFullPrivacyRiskAvailabilityImpactVeryHighDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_availability_impact_very_high_definition }}
            </p>
            <p v-if="!showFullPrivacyRiskAvailabilityImpactVeryHighDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_availability_impact_very_high_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullPrivacyRiskAvailabilityImpactVeryHighDefinition=!showFullPrivacyRiskAvailabilityImpactVeryHighDefinition">
              <span class="cursor-pointer" v-if="!showFullPrivacyRiskAvailabilityImpactVeryHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullPrivacyRiskAvailabilityImpactVeryHighDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.privacy_risk_availability_impact_very_high_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.privacy_risk_availability_impact_very_high_definition }}
          </p>
          <br>
        </div>
        <div class="text-center mt-5 mb-5"
             v-if="!object.risk_category.privacy_risk_availability_impact_very_high_definition && !object.risk_category.privacy_risk_availability_impact_high_definition && !object.risk_category.privacy_risk_availability_impact_low_definition && !object.risk_category.privacy_risk_availability_impact_very_low_definition"
        >
          <h5>{{ $t('system.no_definitions_available') }}</h5>
        </div>
      </div>


      <div v-if="type == 'privacy_probability' || type == 'privacy_confidentiality_probability' || type == 'privacy_integrity_probability' || type == 'privacy_availability_probability'">

        <div v-if="object.risk_category.privacy_risk_probability_very_unlikely_definition">
          <br>
          <label>{{ $t('probability.very_unlikely') }}</label>
          <div v-if="object.risk_category.privacy_risk_probability_very_unlikely_definition.length > 300">
            <p v-if="showFullPrivacyRiskProbabilityVeryUnlikelyDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_probability_very_unlikely_definition }}
            </p>
            <p v-if="!showFullPrivacyRiskProbabilityVeryUnlikelyDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_probability_very_unlikely_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullPrivacyRiskProbabilityVeryUnlikelyDefinition=!showFullPrivacyRiskProbabilityVeryUnlikelyDefinition">
              <span class="cursor-pointer" v-if="!showFullPrivacyRiskProbabilityVeryUnlikelyDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullPrivacyRiskProbabilityVeryUnlikelyDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.privacy_risk_probability_very_unlikely_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.privacy_risk_probability_very_unlikely_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.privacy_risk_probability_unlikely_definition">
          <br>
          <label>{{ $t('probability.unlikely') }}</label>
          <div v-if="object.risk_category.privacy_risk_probability_unlikely_definition.length > 300">
            <p v-if="showFullPrivacyRiskProbabilityUnlikelyDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_probability_unlikely_definition }}
            </p>
            <p v-if="!showFullPrivacyRiskProbabilityUnlikelyDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_probability_unlikely_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullPrivacyRiskProbabilityUnlikelyDefinition=!showFullPrivacyRiskProbabilityUnlikelyDefinition">
              <span class="cursor-pointer" v-if="!showFullPrivacyRiskProbabilityUnlikelyDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullPrivacyRiskProbabilityUnlikelyDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.privacy_risk_probability_unlikely_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.privacy_risk_probability_unlikely_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.privacy_risk_probability_likely_definition">
          <br>
          <label>{{ $t('probability.likely') }}</label>
          <div v-if="object.risk_category.privacy_risk_probability_likely_definition.length > 300">
            <p v-if="showFullPrivacyRiskProbabilityLikelyDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_probability_likely_definition }}
            </p>
            <p v-if="!showFullPrivacyRiskProbabilityLikelyDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_probability_likely_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullPrivacyRiskProbabilityLikelyDefinition=!showFullPrivacyRiskProbabilityLikelyDefinition">
              <span class="cursor-pointer" v-if="!showFullPrivacyRiskProbabilityLikelyDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullPrivacyRiskProbabilityLikelyDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.privacy_risk_probability_likely_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.privacy_risk_probability_likely_definition }}
          </p>
          <br>
        </div>

        <div v-if="object.risk_category.privacy_risk_probability_very_likely_definition">
          <br>
          <label>{{ $t('probability.very_likely') }}</label>
          <div v-if="object.risk_category.privacy_risk_probability_very_likely_definition.length > 300">
            <p v-if="showFullPrivacyRiskProbabilityVeryLikelyDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_probability_very_likely_definition }}
            </p>
            <p v-if="!showFullPrivacyRiskProbabilityVeryLikelyDefinition" class="text-formatted">
              {{ object.risk_category.privacy_risk_probability_very_likely_definition | truncate(300) }}
            </p>
            <div class="text-center mt-3" @click="showFullPrivacyRiskProbabilityVeryLikelyDefinition=!showFullPrivacyRiskProbabilityVeryLikelyDefinition">
              <span class="cursor-pointer" v-if="!showFullPrivacyRiskProbabilityVeryLikelyDefinition">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullPrivacyRiskProbabilityVeryLikelyDefinition">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="object.risk_category.privacy_risk_probability_very_likely_definition.length <= 300"
             class="text-formatted"
          >
            {{ object.risk_category.privacy_risk_probability_very_likely_definition }}
          </p>
          <br>
        </div>
        <div class="text-center mt-5 mb-5"
             v-if="!object.risk_category.privacy_risk_probability_very_likely_definition && !object.risk_category.privacy_risk_probability_likely_definition && !object.risk_category.privacy_risk_probability_unlikely_definition && !object.risk_category.privacy_risk_probability_very_unlikely_definition"
        >
          <h5>{{ $t('system.no_definitions_available') }}</h5>
        </div>
      </div>

      <b-button class="float-right"
                variant="success"
                @click="hideTPModal"
                qid="create-p-cancel-button"
      >
        {{ $t('processes.policies.view.close') }}
      </b-button>
      <br>

  </b-modal>

</div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'ViewDefinitionsModal',
    data: function() {
      return {

        showFullBusinessRiskImpactVeryLowDefinition: false,
        showFullBusinessRiskImpactLowDefinition: false,
        showFullBusinessRiskImpactHighDefinition: false,
        showFullBusinessRiskImpactVeryHighDefinition: false,

        showFullBusinessRiskConfidentialityImpactVeryLowDefinition: false,
        showFullBusinessRiskConfidentialityImpactLowDefinition: false,
        showFullBusinessRiskConfidentialityImpactHighDefinition: false,
        showFullBusinessRiskConfidentialityImpactVeryHighDefinition: false,

        showFullBusinessRiskIntegrityImpactVeryLowDefinition: false,
        showFullBusinessRiskIntegrityImpactLowDefinition: false,
        showFullBusinessRiskIntegrityImpactHighDefinition: false,
        showFullBusinessRiskIntegrityImpactVeryHighDefinition: false,

        showFullBusinessRiskAvailabilityImpactVeryLowDefinition: false,
        showFullBusinessRiskAvailabilityImpactLowDefinition: false,
        showFullBusinessRiskAvailabilityImpactHighDefinition: false,
        showFullBusinessRiskAvailabilityImpactVeryHighDefinition: false,



        showFullPrivacyRiskImpactVeryLowDefinition: false,
        showFullPrivacyRiskImpactLowDefinition: false,
        showFullPrivacyRiskImpactHighDefinition: false,
        showFullPrivacyRiskImpactVeryHighDefinition: false,

        showFullPrivacyRiskConfidentialityImpactVeryLowDefinition: false,
        showFullPrivacyRiskConfidentialityImpactLowDefinition: false,
        showFullPrivacyRiskConfidentialityImpactHighDefinition: false,
        showFullPrivacyRiskConfidentialityImpactVeryHighDefinition: false,

        showFullPrivacyRiskIntegrityImpactVeryLowDefinition: false,
        showFullPrivacyRiskIntegrityImpactLowDefinition: false,
        showFullPrivacyRiskIntegrityImpactHighDefinition: false,
        showFullPrivacyRiskIntegrityImpactVeryHighDefinition: false,

        showFullPrivacyRiskAvailabilityImpactVeryLowDefinition: false,
        showFullPrivacyRiskAvailabilityImpactLowDefinition: false,
        showFullPrivacyRiskAvailabilityImpactHighDefinition: false,
        showFullPrivacyRiskAvailabilityImpactVeryHighDefinition: false,



        showFullBusinessRiskProbabilityVeryUnlikelyDefinition: false,
        showFullBusinessRiskProbabilityUnlikelyDefinition: false,
        showFullBusinessRiskProbabilityLikelyDefinition: false,
        showFullBusinessRiskProbabilityVeryLikelyDefinition: false,

        showFullPrivacyRiskProbabilityVeryUnlikelyDefinition: false,
        showFullPrivacyRiskProbabilityUnlikelyDefinition: false,
        showFullPrivacyRiskProbabilityLikelyDefinition: false,
        showFullPrivacyRiskProbabilityVeryLikelyDefinition: false,

      }
    },
    props: {
      showModal: {
        type: Boolean
      },
      active: {
        type: Boolean
      },
      type: {
        type: String
      },
      object: {
        type: Object
      }
    },
    computed: {
      getClient() {
        return this.$store.state.client
      }
    },
    watch: {
      // Watch when prop changes
      showModal: function (value) {
        if (value) {
          this.showTPModal()
        }
      }
    },
    methods: {
      showTPModal() {
        this.$refs['view-definitions'].show()
      },
      hideTPModal() {
        this.$emit('closeViewModal');
        this.$refs['view-definitions'].hide()
      }
    },
    components: {

    },
    created () {

    }
  }
</script>
